import { z } from 'zod';
import { ISO_DATE_PATTERN } from '@/common/utils/dateFormats';
import { CUSTOM, MONTH, QUARTER, YEAR } from '@/features/teams/components/types';

export const isoDateSearchParam = z.string().regex(ISO_DATE_PATTERN).optional().catch(undefined);

export const periodSearchSchema = {
  period: z.enum([MONTH, QUARTER, YEAR, CUSTOM]).optional().default(MONTH),
  from: isoDateSearchParam,
  to: isoDateSearchParam,
};
